/*---------------------------------------------------------------------------
 The following JavaScript functions control Tender supplier client side functions
-----------------------------------------------------------------------------*/

var TECL_TenderSupplierGeneral = {

    // Close the accordian panel
    InitialiseAccordionControls: function() {

        $(".collapse").on('show.bs.collapse', function() {
            var parentNode = $(this).parent();
            parentNode.find(".panel-heading").addClass("opened");
            parentNode.find(".accordionClose").removeClass("hidden");
            parentNode.find(".accordionOpen").addClass("hidden");
        });

        $(".collapse").on('hide.bs.collapse', function() {
            var parentNode = $(this).parent();
            parentNode.find(".panel-heading").removeClass("opened");
            parentNode.find(".accordionClose").addClass("hidden");
            parentNode.find(".accordionOpen").removeClass("hidden");
        });
    },

    // Show error dialog
    ShowErrorDialog: function(errorMessage) {
        $("#errorText").html(errorMessage);
        $("#errorDialog").modal("show");
    },

    // Display save question dlg for a set amount of time
    DisplayNoticeDlg: function(displayText) {
        $("#displayNoticeDlgText").html(displayText);
        $("#displayNoticeDialog").modal("show");

        function HideSupplierQuestionSavedDlg() {
            $("#displayNoticeDialog").modal("hide");
        }

        // Wait a set amount of time till the dialog is closed
        setTimeout(HideSupplierQuestionSavedDlg, 1000);
    }

};

// Initilise the Tender supplier page
var TECL_TenderSupplierSelect = {

    // Initialise the Tenders select page
    Initialise: function() {
        TECL_TenderSupplierGeneral.InitialiseAccordionControls();

        window.scrollTo(0, 0);

        // Open the accordian for active tenders
        var collapseNodes = $("#accordion_ActiveTenders").find(".panel-collapse");
        if (collapseNodes.length > 0) {
            collapseNodes.collapse("show");
        }
    }

};

// Initilise the Tender viewer page
var TECL_TenderViewer = {

    // Initialise the Tenders select page
    Initialise: function() {
        TECL_TenderSupplierGeneral.InitialiseAccordionControls();

        window.scrollTo(0, 0);
    }

};

// Initilise the Supplier Tender Editor page
var TECL_TenderSupplierEditor = {

    // Initialise the Tenders select page
    Initialise: function() {
        TECL_TenderSupplierGeneral.InitialiseAccordionControls();
        window.scrollTo(0, 0);
    },

    // download a file
    DownloadFile: function(fileId) {
        window.location = baseSiteUrl + "TenderSupplierSurface/DownloadFile?fileId=" + fileId;
    },

    RemoveFile: function(fileId, elementId) {
        if (fileId && elementId) {
            if (TECL_Master.AddLock("TenderSupplier_RemoveFile")) {

                $.ajax({
                    url: baseSiteUrl + "TenderSupplierSurface/RemoveFile",
                    type: "POST",
                    data: {
                        documentId: fileId
                    },
                    error: function(exc) {
                        TECL_Master.ClearLock("TenderSupplier_RemoveFile");
                    },
                    success: function(result) {
                        TECL_Master.ClearLock("TenderSupplier_RemoveFile");
                        if (result && result === true) {
                            $(elementId).remove();
                        }
                    }
                });
            }
        }
    },

    // On successful upload of a proposal file
    onSuccess_proposalFiles: function(e) {
        if (TECL_Master.AddLock("onSuccess_proposalFiles")) {
            if (e.operation == "upload" && e.files != null && e.files.length > 0) {
                var file = e.files[0].rawFile;

                if (file) {
                    var tenderId = $("#TenderId").val();
                    $.ajax({
                        url: baseSiteUrl + "TenderSupplierSurface/SaveDownloadedFile",
                        type: "POST",
                        data: {
                            fileName: file.name,
                            documentType: 0, // Proposal enum number
                            tenderId: tenderId
                        },
                        error: function(exc) {
                            TECL_Master.ClearLock("onSuccess_proposalFiles");
                        },
                        success: function(html) {
                            TECL_Master.ClearLock("onSuccess_proposalFiles");
                            if (html != null) {
                                var listContainer = $("#FileUploader_proposalFileUploader").find("[name=UploadFilesList]");
                                $(html).appendTo(listContainer);
                            }
                        }
                    });
                }
            }
        }
    },

    // On successful upload of a case studies file
    onSuccess_casestudiesFiles: function(e) {
        if (TECL_Master.AddLock("onSuccess_casestudiesFiles")) {
            if (e.operation == "upload" && e.files != null && e.files.length > 0) {
                var file = e.files[0].rawFile;

                if (file) {
                    var tenderId = $("#TenderId").val();
                    $.ajax({
                        url: baseSiteUrl + "TenderSupplierSurface/SaveDownloadedFile",
                        type: "POST",
                        data: {
                            fileName: file.name,
                            documentType: 1, // Case Studies enum number
                            tenderId: tenderId
                        },
                        error: function(exc) {
                            TECL_Master.ClearLock("onSuccess_casestudiesFiles");
                        },
                        success: function(html) {
                            TECL_Master.ClearLock("onSuccess_casestudiesFiles");
                            if (html != null) {
                                var listContainer = $("#FileUploader_caseStudiesFileUploader").find("[name=UploadFilesList]");
                                $(html).appendTo(listContainer);
                            }
                        }
                    });
                }
            }
        }
    },

    // On successful upload of a term and conditions file
    onSuccess_tandcsFiles: function(e) {
        if (TECL_Master.AddLock("onSuccess_tandcsFiles")) {
            if (e.operation == "upload" && e.files != null && e.files.length > 0) {
                var file = e.files[0].rawFile;

                if (file) {
                    var tenderId = $("#TenderId").val();
                    $.ajax({
                        url: baseSiteUrl + "TenderSupplierSurface/SaveDownloadedFile",
                        type: "POST",
                        data: {
                            fileName: file.name,
                            documentType: 2, // T&C's enum number
                            tenderId: tenderId
                        },
                        error: function(exc) {
                            TECL_Master.ClearLock("onSuccess_tandcsFiles");
                        },
                        success: function(html) {
                            TECL_Master.ClearLock("onSuccess_tandcsFiles");
                            if (html != null) {
                                var listContainer = $("#FileUploader_tandcsFileUploader").find("[name=UploadFilesList]");
                                $(html).appendTo(listContainer);
                            }
                        }
                    });
                }
            }
        }
    },

    // Open and close an answer
    OpenCloseAnswer: function(answerControlId) {
        var answerPanel = $("#AnswerText_" + answerControlId).first();
        var openIcon = $("#OpenIcon_" + answerControlId).first();

        if (answerPanel && openIcon) {
            if ($(answerPanel).hasClass("hidden")) {
                $(answerPanel).removeClass("hidden");
                $(openIcon).removeClass("fa-plus");
                $(openIcon).addClass("fa-minus");
            } else {
                $(answerPanel).addClass("hidden");
                $(openIcon).removeClass("fa-minus");
                $(openIcon).addClass("fa-plus");
            }
        }
    },

    // Save the required questions data
    SaveRequiredQuestions: function() {

        TECL_TenderSupplierEditor.ValidateRequiredQuestionData();
        var saveQuestionsData = TECL_TenderSupplierEditor.GetRequiredQuestionDatas();
        var tenderId = $("#TenderId").val();

        if (saveQuestionsData && tenderId) {

            if (TECL_Master.AddLock("SaveRequiredQuestions")) {
                $.ajax({
                    url: baseSiteUrl + "TenderSupplierSurface/SaveRequiredQuestions",
                    type: "POST",
                    dataType: "json",
                    data: {
                        tenderId: tenderId,
                        saveData: saveQuestionsData
                    },
                    error: function(exc) {
                        TECL_Master.ClearLock("SaveRequiredQuestions");
                    },
                    success: function(saved) {
                        TECL_Master.ClearLock("SaveRequiredQuestions");
                        if (saved && saved === true) {
                            TECL_TenderSupplierGeneral.DisplayNoticeDlg("Required information saved");
                        }
                    }
                });
            }
        }
    },

    // Validate the required questions data
    ValidateRequiredQuestionData: function() {
        var isValid = true;
        $("#tenderRequiredInformation").find(".tenderSupplierRequiredQuestionRow").each(function() {
            var value = $(this).find("[name=AnswerText]").val();

            if (value) {
                // Make sure the validation text is hidden
                $(this).find("[name=ValidationText]").addClass("hidden");
            } else {
                // Report a fail and show the validation text
                isValid = false;
                $(this).find("[name=ValidationText]").removeClass("hidden");
            }
        });
        return isValid;
    },

    // Gets the required questions data
    GetRequiredQuestionDatas: function() {
        var saveQuestionsData = [];
        $("#tenderRequiredInformation").find(".tenderSupplierRequiredQuestionRow").each(function() {
            var fieldName = $(this).attr("data-fieldName");
            var value = $(this).find("[name=AnswerText]").val();

            questionsData = {
                FieldName: fieldName,
                AnswerValue: value
            }

            saveQuestionsData.push(questionsData);
        });
        return saveQuestionsData;
    },

    // Save the suppliers answer
    SaveSupplierAnswer: function(questionId) {
        var tenderId = $("#TenderId").val();
        var answerText = $("#AnswerText_" + questionId).find("[name=answerText]").val();

        if (tenderId && questionId && answerText) {

            if (TECL_Master.AddLock("SaveSupplierAnswer")) {
                $.ajax({
                    url: baseSiteUrl + "TenderSupplierSurface/SaveSupplierAnswer",
                    type: "POST",
                    dataType: "json",
                    data: {
                        tenderId: tenderId,
                        answerText: answerText,
                        questionId: questionId
                    },
                    error: function(exc) {
                        TECL_Master.ClearLock("SaveSupplierAnswer");
                    },
                    success: function(saved) {
                        TECL_Master.ClearLock("SaveSupplierAnswer");
                        if (saved && saved === true) {
                            TECL_TenderSupplierGeneral.DisplayNoticeDlg("Answer saved");
                        }
                    }
                });
            }
        }
    },

    // Show the save question dialog
    ShowQuestionDialog: function() {
        $("#askQuestionText").val("");
        $("#supplierAskQuestionDlg").modal({
            backdrop: 'static',
            keyboard: false
        });
        $("#supplierAskQuestionDlg").modal("show");
    },

    // Save the suppliers question
    SaveSupplierQuestion: function() {
        var tenderId = $("#TenderId").val();
        $("#missingQuestionTextValidation").addClass("hidden");

        if (tenderId) {
            var questionText = $("#askQuestionText").val();

            if (questionText) {
                if (TECL_Master.AddLock("SaveSupplierQuestion")) {
                    $.ajax({
                        url: baseSiteUrl + "TenderSupplierSurface/SaveSupplierQuestion",
                        type: "POST",
                        data: {
                            tenderSupplierId: tenderId,
                            questionText: questionText
                        },
                        error: function(exc) {
                            TECL_Master.ClearLock("SaveSupplierQuestion");
                        },
                        success: function(questionHtml) {
                            TECL_Master.ClearLock("SaveSupplierQuestion");
                            $("#supplierAskQuestionDlg").modal("hide");

                            if (questionHtml) {
                                TECL_TenderSupplierGeneral.DisplayNoticeDlg("Question saved");
                                $("#tenderQuestionTitleRow").removeClass("hidden");
                                $("#supplierQuestionRows").after(questionHtml);
                            }
                        }
                    });
                }
            } else {
                $("#missingQuestionTextValidation").removeClass("hidden");
            }
        }
    }

};